module.exports = __webpack_public_path__ + "static/media/cars.e999c916.png";